import { render, staticRenderFns } from "./Newsforyou.vue?vue&type=template&id=0584b248&scoped=true&"
import script from "./Newsforyou.vue?vue&type=script&lang=js&"
export * from "./Newsforyou.vue?vue&type=script&lang=js&"
import style0 from "./Newsforyou.vue?vue&type=style&index=0&id=0584b248&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0584b248",
  null
  
)

export default component.exports